import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const createAuthoringLegislationGroup = api(async function createAuthoringLegislationGroup({ name, parentId }) {
    return mutate(
        gql`
            mutation CreateAuthoringLegislationGroup($name: String!, $parentId: String) {
                createAuthoringLegislationGroup(name: $name, parentId: $parentId) {
                    id
                    legacyId
                    name
                    parentId
                }
            }
        `,
        { name, parentId },
        { returns: "createAuthoringLegislationGroup" }
    )
})
